import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { StatusElement, StatusService } from '../shared/services/status.service';
import { Subject, takeUntil } from 'rxjs';
import { HcSort, HcTableDataSource, PaginationComponent } from '@healthcatalyst/cashmere';
import { TypeElement, TypeService } from '../shared/services/type.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OktaService } from "../shared/services/okta.service";
import { environment } from '../../environments/environment';

/** Definitions documentation  */
@Component({
    selector: 'pd-definitions',
    templateUrl: './definitions.component.html',
    styleUrls: ['./definitions.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DefinitionsComponent implements OnInit, AfterViewInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    typesDataSource: HcTableDataSource<TypeElement> = new HcTableDataSource();
    statusesDataSource: HcTableDataSource<StatusElement> = new HcTableDataSource();
    loading = true;
    loadError = false;
    typesDisplayedColumns: string[] = ['name', 'category', 'description'];
    typesPageSize: number = 10;
    statusesDisplayedColumns: string[] = ['name', 'description'];
    statusesPageSize: number = 10;

    @ViewChild(HcSort)
    typesSort: HcSort;

    @ViewChild('typesPaginator')
    typesPaginator: PaginationComponent;

    @ViewChild('statusesPaginator')
    statusesPaginator: PaginationComponent;

    get typesListLength(): number {
        return this.typesDataSource.filteredData ? this.typesDataSource.filteredData.length : 0;
    }

    get statusesListLength(): number {
        return this.statusesDataSource.filteredData ? this.statusesDataSource.filteredData.length : 0;
    }

    constructor (
        private typeService: TypeService, 
        private statusService: StatusService, 
        private oktaService: OktaService, 
        private http: HttpClient 
    ) {}

    ngOnInit(): void {
        this.typeService.allTypesUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.loading = false;
                this.loadError = false;
                this.typesDataSource = new HcTableDataSource(list);
                if (this.typesSort && this.typesPaginator) {
                    this.typesDataSource.sort = this.typesSort;
                    this.typesDataSource.paginator = this.typesPaginator;
                }
            } else {
                this.loadError = this.typeService.loadFailed;
                if (!this.loadError) {
                    this.typeService.loadAllTypes();
                } else {
                    this.loading = false;
                }
            }
        });

        this.statusService.statusListUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.loading = false;
                this.loadError = false;
                this.statusesDataSource = new HcTableDataSource(list);
                if (this.statusesPaginator) {
                    this.statusesDataSource.paginator = this.statusesPaginator;
                }
            } else {
                this.loadError = this.typeService.loadFailed;
                if (!this.loadError) {
                    this.statusService.refresh();
                } else {
                    this.loading = false;
                }
            }
        });
    }

    ngAfterViewInit(): void {
        this.typesDataSource.sort = this.typesSort;
        this.typesDataSource.paginator = this.typesPaginator;
        this.statusesDataSource.paginator = this.statusesPaginator;
    }

    generateDownload(): void {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);

        this.http.get(environment.azure.url + '/admin.definitions.generate', { responseType: 'blob', headers: headers })
            .subscribe({
                next: (data) => {
                    const blob = new Blob([data], { type: 'text/csv' });
                    const url= window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.setAttribute('type', 'hidden');  
                    a.href = url;  
                    a.download = 'Definitions.csv';  
                    a.click(); 
                    a.remove();
                },
                error: (msg) => {
                    console.log(msg);
                }
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
